const routes = [
    {
        path: "/placement/exam/classrooms/:id",
        component: () => import("../pages/PlacementExamClassroomsTable"),
        meta: {
            isAuthenticated: true,
            permission: "placementexamclassroom_index"
        }
    },

];

export default routes;
